import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'antd';
import { parse } from 'query-string';

import * as pageActions from '../../../data/redux/page_details/actions';
import * as adminActions from '../../../data/redux/admin_details/actions';

import { APP_PAGES, ROUTE_PATH } from '../../../data/config/constants';
import { showMessage, checkPassword, encrypt } from '../../../data/config/utils';
import { MODULE_MESSAGE, BRAND_INFO } from '../../../data/config/urls';
import { IMG_ERROR } from '../../../data/assets/img';

import SpinnerLoader from '../../../components/spinnerloader';
import ShowMessage from '../../../components/showmessage';
import LogoCard from '../../../components/logocard';
import InputFormItem from '../../../components/form/formitem/inputformitem';
import ModalFooter from '../../../components/modalfooter';

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class ResetPasswordForm extends React.PureComponent {
  componentWillMount() {
    this.props.actions.pageChanged(APP_PAGES.RESET_PASSWORD, 'ORI Dashboard');
  }

  componentDidMount() {
    const { actions, form, location } = this.props;
    const query_params = parse(location.search);
    if (query_params && query_params.email && query_params.token && query_params.tokenType) {
      const payload = {
        email: query_params.email,
        token: query_params.token,
        tokenType: query_params.tokenType,
      };
      actions.verifyToken(payload);
      form.validateFields();
    } else {
      showMessage('error', 'you are trying to access invalid link.');
      this.goToLoginPage();
    }
  }

  handleInputChange = event => {
    this.props.form.setFieldsValue({
      [event.target.name]: event.target.value
    });
    this.props.form.validateFields();
  };

  handleSubmit = e => {
    e.preventDefault();
    const { form, location, actions, match } = this.props;
    form.validateFields(err => {
      if (!err) {
        const data = form.getFieldsValue(['password', 'confirm_password']);
        if (data.password && data.confirm_password && data.password === data.confirm_password) {
          if (checkPassword(data.password)) {
            const query_params = parse(location.search);
            if (query_params && query_params.email && query_params.token) {
              const password = process.env.REACT_APP_CIPHER_PUBLIC_KEY ? encrypt(data.password) : data.password
              const payload = {
                email: query_params.email,
                token: query_params.token,
                password,
                isEncrypted: password !== data.password
              };
              if (match.path === ROUTE_PATH.ACTIVATE_USER) {
                actions.activateUser(payload, this.goToLoginPage);
              } else {
                actions.resetPassword(payload, this.goToLoginPage);
              }
            } else {
              showMessage('error', 'you are trying to access invalid link.');
              this.goToLoginPage();
            }
          } else {
            showMessage('warning', 'password must be 8 to 15 characters length, which contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character');
            form.resetFields();
          }
        } else {
          showMessage('warning', 'New Password and Confirm Password do not match. please try again');
          form.resetFields();
        }
      } else {
        showMessage('error', 'Please enter/validate new password  and confirm password!');
      }
    });
  };

  handleResendActivationLink = () => {
    const { location, actions } = this.props;
    const query_params = parse(location.search);
    if (query_params && query_params.email && query_params.token && query_params.tokenType) {
      const payload = {
        email: query_params.email,
        tokenType: query_params.tokenType,
        host: window.location.origin,
      };
      actions.resendActivationLink(payload, this.goToLoginPage);
    } else {
      showMessage('error', 'you are trying to access invalid activation link.');
      this.goToLoginPage();
    }
  };

  goToLoginPage = () => {
    this.props.history.push(ROUTE_PATH.LOGIN);
  };

  goToForgotPasswordPage = () => {
    this.props.history.push(ROUTE_PATH.FORGOT_PASSWORD);
  };

  render() {
    const { form, admin_details, match } = this.props;
    const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = form;
    const passwordError = isFieldTouched('password') && getFieldError('password');
    const confirmPasswordError = isFieldTouched('confirm_password') && getFieldError('confirm_password');
    const is_invited_user = match.path === ROUTE_PATH.ACTIVATE_USER;
    if (admin_details.loaders.token_verifying && !admin_details.loaders.token_verified) {
      return (
        <SpinnerLoader text="verifying" size="large" />
      );
    } else if (!admin_details.loaders.token_verifying && admin_details.loaders.token_verified) {
      return (
        <div className="ori-animated ori-fade-in-left ori-pad-10">
          <LogoCard container_class="ori-b-mrgn-20 ori-pad-15 ori-text-center" image_src={BRAND_INFO.logo_url} title={`Hi ${admin_details.user_info.firstName ? admin_details.user_info.firstName : 'User'},`} title_class="ori-font-md ori-capitalize" description={is_invited_user ? MODULE_MESSAGE.AUTH.ACTIVATE_USER.description : MODULE_MESSAGE.AUTH.RESET_PASSWORD.description} />
          <Form layout="vertical" onSubmit={this.handleSubmit}>
            <InputFormItem getFieldDecorator={getFieldDecorator} validate_status={passwordError ? "warning" : ""} help={passwordError || ''} error_key="password" rules={[{ required: true, message: 'Please enter new password!' }]} type="password" placeholder="New Password" input_name="password" disabled={admin_details.loaders.auth_loading} onChange={this.handleInputChange} />
            <InputFormItem getFieldDecorator={getFieldDecorator} validate_status={confirmPasswordError ? "warning" : ""} help={confirmPasswordError || ''} error_key="confirm_password" rules={[{ required: true, message: 'Please confirm password!' }]} type="password" placeholder="Confirm Password" input_name="confirm_password" disabled={admin_details.loaders.auth_loading} onChange={this.handleInputChange} />
            <div className="ori-full-width ori-text-center ori-b-pad-10">
              <p className="ori-font-xs">{`By continuing on ${BRAND_INFO.shortend_name} chatbot, you agree to our`} <span className="ori-font-primary ori-link-primary">Terms & Conditions</span>  and <span className="ori-font-primary ori-link-primary">Privacy Policy</span>.</p>
            </div>
            <ModalFooter capsule_button btn_style={{ minWidth: '40%' }} btn_class="ori-height-40 ori-uppercase" button_ok_text={admin_details.loaders.auth_loading ? "SAVING" : "SAVE"} button_ok_type="submit" loading={admin_details.loaders.auth_loading} button_ok_disabled={hasErrors(getFieldsError()) || admin_details.loaders.auth_loading} handleCancelClick={this.goToLoginPage} />
          </Form>
        </div>
      );
    } else if (!admin_details.loaders.token_verifying && !admin_details.loaders.token_verified) {
      if (is_invited_user) {
        return (
          <ShowMessage img_src={IMG_ERROR} button_type="primary" button_class="ori-border-radius-20 ori-font-xs" button_text={admin_details.loaders.auth_loading ? "ACTIVATION LINK SENDING" : "RESEND ACTIVATION LINK"} height={100} width={100} button_loading={admin_details.loaders.auth_loading} title={MODULE_MESSAGE.AUTH.ACTIVATE_USER.token_error_title} message={MODULE_MESSAGE.AUTH.ACTIVATE_USER.token_error_description} handleButtonClick={this.handleResendActivationLink} show_button />
        );
      } else {
        return (
          <ShowMessage img_src={IMG_ERROR} button_type="primary" button_class="ori-border-radius-20 ori-font-xs" button_text="FORGOT PASSWORD" height={100} width={100} title={MODULE_MESSAGE.AUTH.RESET_PASSWORD.token_error_title} message={MODULE_MESSAGE.AUTH.RESET_PASSWORD.token_error_description} handleButtonClick={this.goToForgotPasswordPage} show_button />
        );
      }
    } else {
      return null;
    }
  }
}

const mapStateToProps = state => {
  return {
    page_details: state.page_details,
    admin_details: state.admin_details,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(Object.assign({}, pageActions, adminActions), dispatch)
  };
};

ResetPasswordForm.propTypes = {
  form: PropTypes.object,
  actions: PropTypes.object,
  admin_details: PropTypes.object,
  history: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
};

const ResetPassword = Form.create()(ResetPasswordForm);

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(ResetPassword);


// WEBPACK FOOTER //
// ./src/app/authcontainer/resetpassword/index.js